import { browserHistory } from 'react-router';
import { call, put, select, takeEvery, takeLatest, delay } from 'redux-saga/effects';
import * as api from '../../services/classification/api_classification';
import * as common from '../sagasCommon';
import * as apiCommon from '../../services/apiCommon';
import * as DocType from '../../constants/constant_doc_types';

export function * fetchListClassificationSaga(feathersApp) {
  yield takeLatest('FETCH_LIST_CLASSIFICATION', callListClassification, feathersApp);
}
function * callListClassification(feathersApp, action) {
  const { filters, silent } = action;
  yield common.showProgressListTable(silent);
  try {
    const dataParams = { 
      filters,
      list_type: DocType.CLASSIFICATION
    };
    const tableData = yield call(apiCommon.getDocs, feathersApp, dataParams);
    yield call(common.doneListTable, { rows: tableData.data, total_rows: tableData.total });
  } catch (error) {
    yield common.showErrorListTable(error);
  }
}

export function * deleteClassificationFromListSaga(feathersApp) {
  yield takeEvery('DELETE_CLASSIFICATION_FROM_LIST', callDeleteClassificationFromList, feathersApp);
}

function* callDeleteClassificationFromList(feathersApp, action) {
  yield deleteClassification(feathersApp, action);
  yield delay(2000); 
  yield callListClassification(feathersApp, { silent: true });
}

function * deleteClassification(feathersApp, action) {
  yield put({ type: 'DELETE_RECORD_INPROGRESS' });
  try {
      const { id } = action;
      let result = null;
      if(id) {
          const state = yield select();
          const { tenant, user } = state;
          const { id } = action;
          const params = { tenant, user, id };
          result = yield call(api.deleteClassification, feathersApp, params);
      }
      yield put({ type: "DELETE_RECORD_DONE", payload: { id, docType: DocType.CLASSIFICATION }});
      return result;
  } catch (error) {
      yield put({ type: 'DELETE_RECORD_ERROR', error })
  }
}


export function * deleteClassificationSaga(feathersApp) {
  yield takeEvery('DELETE_CLASSIFICATION', callDeleteClassification, feathersApp);
}

function* callDeleteClassification(feathersApp, action) {
  const result = yield deleteClassification(feathersApp, action);
  yield delay(2000); 
  if(result) {
    browserHistory.push('/admin/classification');
  }
}

export function * fetchClassificationForEditSaga(feathersApp) {
  yield takeEvery('FETCH_CLASSIFICATION_FOR_EDIT', callFetchClassificationForEdit, feathersApp);
}

function* callFetchClassificationForEdit(feathersApp, action) {
  const { tenant, user } = yield select();
  const { id, silent } = action;
  try {
    if(id) {
      yield common.showProgressDataById(silent);
      const fetchParams = { tenant, user, id };
      const doc = yield call(api.fetchClassificationById, feathersApp, fetchParams);
      console.log("fetchClassificationForEdit", doc);
      yield common.doneDataById(doc);
    }
  } catch (error) {
    yield put({ type: "FETCH_DATA_BY_ID_ERROR", error: error });
  }
}



export function * saveClassificationSaga(feathersApp) {
  yield takeEvery("SAVE_CLASSIFICATION", callSaveClassification, feathersApp);
}
function * callSaveClassification(feathersApp, action) {
  yield common.showProgressSaveRecord();
  const { tenant, user } = yield select();
  try {
    const result = yield call(api.saveClassification, feathersApp, {
      tenant,
      user,
      data: action.data
    });
    const id = result && result.id;
    if (id) {
      yield callFetchClassificationForEdit(feathersApp, { id, silent: true });
      browserHistory.push(`/admin/classification/edit/${id}`);
      yield common.doneSaveRecord(result, 'Classification was saved');
    } else {
      yield common.showErrorSaveRecord(new Error('Error in saving: Classification'));  
    }
  } catch (error) {
    yield common.showErrorSaveRecord(error);
  }
}
